/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import { ScrollAwareItem } from '../ScrollAware';
import AppNavLeftRightNavigation from './appNavBits/AppNavLeftRightNavigation';
import AppNavHeaderTitle from './appNavBits/AppNavHeaderTitle';
import { useUIState } from '../../hooks/useUIState';
import { useActiveProfile } from '../../hooks/useProfile';

interface Props {
  hasDropShadow: boolean;
}
const AppNavTopLevel: React.FC<Props> = (props) => {
  const { hasDropShadow } = props;

  const [, profileActions] = useActiveProfile();
  const [, uiActions] = useUIState();

  return (
    <ScrollAwareItem isSticky stickyPosition={0} isNav hasDropShadow={hasDropShadow}>
      {
        ({ displayTitle }) => (
          <AppNavLeftRightNavigation
            className="bkgd-color-profile"
            avatarAction={() => {
              uiActions.showAppMenu();
            }}
            notification={() => {}}
            profile={profileActions.instantiateProfile()}
          >
            <AppNavHeaderTitle>{displayTitle}</AppNavHeaderTitle>
          </AppNavLeftRightNavigation>
        )
      }
    </ScrollAwareItem>
  );
};

export default AppNavTopLevel;
